import { ArrowUpCircle } from 'lucide-preact'
import type { WorkflowSettingsLevel } from '@/api/workflowSettings'

interface Props {
  level: WorkflowSettingsLevel
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

export function InheritSettingsToggle({ level, checked, onChange, disabled = false }: Props) {
  const parentLabel = level === 'web' ? 'campaign' : 'workspace'

  return (
    <div className="mb-6 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-4 shadow-sm">
      <label className="flex items-start gap-3 cursor-pointer group">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange((e.target as HTMLInputElement).checked)}
          className="mt-0.5 h-4 w-4 rounded border-slate-300 dark:border-slate-600 focus:ring-primary-500 dark:focus:ring-primary-400 text-primary-600 dark:text-primary-500 disabled:cursor-not-allowed disabled:opacity-50"
        />
        <div className="flex-1">
          <span className="text-sm font-medium text-slate-900 dark:text-white">
            Use {parentLabel} settings
          </span>
          <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
            {checked
              ? `This ${level} inherits its asset workflow settings from the ${parentLabel} level. Uncheck to customize.`
              : `This ${level} uses its own custom settings. Check to inherit from the ${parentLabel} level instead.`
            }
          </p>
        </div>
      </label>
      {checked && (
        <div className="mt-3 flex items-center gap-2 text-sm text-primary-600 dark:text-primary-400">
          <ArrowUpCircle className="w-4 h-4" />
          <span>Settings are inherited from the {parentLabel} level</span>
        </div>
      )}
    </div>
  )
}
